import { useEffect } from 'react';

// Copies header text into each cell's data-label so `.mobile-cards` tables can stack on phones.
const labelTables = () => {
  document.querySelectorAll('table.mobile-cards').forEach((table) => {
    const headers = Array.from(table.querySelectorAll('thead th')).map((th) => th.textContent.trim());
    table.querySelectorAll('tbody tr, tfoot tr').forEach((row) => {
      let col = 0;
      Array.from(row.children).forEach((cell) => {
        const label = headers[col] || '';
        if (cell.getAttribute('data-label') !== label) cell.setAttribute('data-label', label);
        col += cell.colSpan || 1;
      });
    });
  });
};

export const useMobileTableLabels = () => {
  useEffect(() => {
    let frame = null;
    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = null; labelTables(); });
    };
    labelTables();
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => { observer.disconnect(); if (frame) cancelAnimationFrame(frame); };
  }, []);
};
